import { Constants } from "../utils/constants";
import { GuestApiAuthenticated } from "./GuestApiAuthenticated";

export const checkValidOtpandpassword = (otp, newPassword) => {
  return GuestApiAuthenticated.post(
    Constants.URL.checkValidOtpandpassword +
      `?password=${encodeURIComponent(newPassword)}&ticketId=${otp}`,

    {
      headers: {
        "content-type": "application/json",
      },
    },
  );
};

export const sendpasswordresetlink = (email) => {
  return GuestApiAuthenticated.get(Constants.URL.forgotpassword + "/" + email, {
    headers: {
      "content-type": "application/json",
    },
  });
};
